<template>
  <div>
    <!-- 弹窗 -->
    <el-dialog
        :before-close="handleCloses"
        :close-on-click-modal="false"
        :visible.sync="settingsVisible"
        title="个人设置"
        top="15vh"
        width="800px"
    >
      <div class="tabs-box">
        <div class="tabs-list">
          <div
              v-for="item in list"
              :key="item.type"
              :class="[item.type===tab_index?'item-active':'']"
              class="tab-item"
              @click="tabClick(item.type)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="tabs-content">
          <div v-if="tab_index==='1'" class="tabs-info">
            <el-form
                ref="createForm"
                :model="createForm"
                label-position="top"
                label-width="92px"
            >
              <el-form-item label="用户名">
                <el-input
                    v-model="createForm.nickname"
                    placeholder="请输入"
                    size="medium"
                    style="width: 306px"
                />
              </el-form-item>
              <el-form-item label="头像">
                <el-upload
                    ref="feedbackUploader"
                    :action="set_avatar_url"
                    :data="{}"
                    :headers="headers"
                    :on-error="visitErr"
                    :on-success="visitUpload"
                    :show-file-list="false"
                    accept=".png,.jpg,.jpeg"
                    class="avatar-uploader"
                    list-type="text">
                  <img v-if="imageUrl" :src="imageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
          <div v-else-if="tab_index==='2'" class="tabs-tone tabs-radio">
            <div class="identity-text">
              您可以选择系统自带的不同音色，作为朗读对话的声音，
              注意：特定智能体中，由于功能需要无法自选音色。
            </div>
            <div class="identity-box">
              <el-radio-group v-model="voice_id">
                <el-radio v-for="(el , edx) in toneList" :key="edx" :label="el.id">{{ el.name }}</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div v-else-if="tab_index==='3'" class="tabs-info">
            <div class="identity-text">
              您可以通过文字描述，让智能体认识您。如姓名、年龄性别、职业、性格、爱好、偏好等等，以训练该模型与真实的使用对象互动。
            </div>
            <div class="identity-box">
              <div v-for="(item,index) in rows" :key="index" class="identity-item">
                <div class="identity-box-title">
                  <span>智能体：{{ item.robot_name }}</span>
                  <el-switch
                      v-model="item.enable"
                      active-color="#409EFF"
                      inactive-color="#DCDFE6"
                  />
                </div>
                <el-input
                    v-model="item.content"
                    :autosize="{ minRows: 2 }"
                    placeholder="请输入内容"
                    style="width: 100%"
                    type="textarea"
                />
              </div>
            </div>
          </div>
        </div>
        <el-button class="save-btn" size="medium" type="primary" @click="confirm">确定</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>

import {base_list, enable_voice, profile_index, save_base, set_avatar, set_nickname, voice_list} from "@/api/login";
import {getToken} from "@/utils/auth"

export default {
  props: {
    settingsVisible: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      createForm: {nickname: ''},
      list: [
        {
          type: '1',
          name: '用户设置'
        },
        {
          type: '2',
          name: '音色配置'
        },
        {
          type: '3',
          name: '身份配置'
        }
      ],
      tab_index: '1',
      set_avatar_url: set_avatar(),
      headers: {'x-access-token': getToken()},
      imageUrl: '',
      rows: [],
      toneList: [],
      voice_id: null
    }
  },
  mounted() {
    this.profile_index()
  },
  methods: {
    voice_list() {
      voice_list().then(res => {
        this.toneList = res.result.rows
        this.voice_id = res.result.rows.find(el => el.enable).id
      }).catch(err => {
      })
    },
    base_list() {
      base_list({}).then(res => {
        this.rows = res.result.rows
      }).catch(() => {
      })
    },
    save_base() {
      save_base({
        base_rows: JSON.stringify(this.rows)
      }).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.$emit('update:settingsVisible', false)
      }).catch(() => {
      })
    },
    set_nickname() {
      set_nickname({
        nickname: this.createForm.nickname
      }).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.$emit('update:settingsVisible', false)
        this.$emit('settingsSave')
      }).catch()
    },
    profile_index() {
      profile_index().then(res => {
        this.createForm.nickname = res.result.nickname
        this.imageUrl = res.result.avatar_url
      }).catch(err => {
      })
    },
    visitUpload(response, file, fileList) {
      if (response.code === 200) {
        this.imageUrl = response.result.avatar_url
      } else {
        this.$message.error(response.result)
      }
    },
    visitErr(err) {
      this.$message.error(err.result)
    },
    handleCloses() {
      this.$emit('update:settingsVisible', false)
    },
    tabClick(e) {
      this.tab_index = e
      if (this.tab_index === '1') {
        this.profile_index()
      } else if (this.tab_index === '2') {
        this.voice_list()
      } else if (this.tab_index === '3') {
        this.base_list()
      }
    },
    enable_voice() {
      enable_voice({id: this.voice_id}).then(res => {
        this.$message.success('启用成功')
        this.$emit('update:settingsVisible', false)
      }).catch(err => {
      })
    },
    // 确定
    confirm() {
      if (this.tab_index === '1') {
        this.set_nickname()
      } else if (this.tab_index === '2') {
        this.enable_voice()
      } else if (this.tab_index === '3') {
        this.save_base()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 0;
}

.tabs-box {
  height: calc(100vh - 56px - 30vh);
  display: flex;
  align-items: flex-start;
  position: relative;

  .save-btn {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }

  .tabs-list {
    width: 128px;
    flex-shrink: 0;
    height: 100%;
    border-right: 1px solid #EEEEEE;
    text-align: center;
    box-sizing: border-box;
    line-height: 50px;
    color: #0F172A;

    .tab-item {
      cursor: pointer;
    }

    .item-active {
      background: #EEEEEE;
    }
  }

  .tabs-content {
    flex: 1;
    overflow-y: auto;
    height: calc(100vh - 56px - 30vh - 52px);

    .tabs-tone {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #858B9F;
    }

    .tabs-radio {
      display: inline-block;
      margin: 20px 20px 10px 20px;

      ::v-deep .el-radio-group {
        margin-top: 20px;
        width: 100%;
      }

      ::v-deep .el-radio, .el-radio__inner, .el-radio__input {
        display: flex;
        margin-bottom: 20px;
        padding: 12px;
        background: #F7F7F7;
        border-radius: 4px;
        color: #1A1A1A;
        width: 100%;
      }
    }

    .tabs-info {
      //background: #EEEEEE;
      margin: 20px 20px 10px 20px;

      .identity-text {
        color: #858B9F;
        line-height: 20px;
        text-align: left;
        margin-bottom: 20px;
      }

      .identity-box {

        .identity-item {
          padding: 12px;
          background: #F7F7F7;
          border-radius: 4px;
          margin-bottom: 10px;

          .identity-box-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 12px;
            color: #1A1A1A;
            line-height: 20px;
          }
        }

      }

      ::v-deep .el-form-item__label {
        line-height: 32px;
        color: #0F172A;
      }
    }

  }
}

::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

::v-deep.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>
